import { OnboardingStatus, SectionStatus } from "@/redux/slices/onboarding/types";

export const isSectionComplete = (section: SectionStatus): boolean => {
  return section.isCompleted && section.isValid;
};

export const isOnboardingFullyComplete = (onboardingStatus: OnboardingStatus | undefined): boolean => {
  if (!onboardingStatus) return false;

  return onboardingStatus.overallCompletion.isOnboardingComplete;
};

export const isSimulationSectionUnlocked = (onboardingStatus: OnboardingStatus | undefined): boolean => {
  if (!onboardingStatus) return false;

  const gettingStartedComplete = onboardingStatus.gettingStarted.isCompleted;

  const businessSettingsComplete = onboardingStatus.businessSettings.isCompleted;
  const tripSettingsComplete = onboardingStatus.tripSettings.isCompleted;

  return gettingStartedComplete && businessSettingsComplete && tripSettingsComplete;
};

export const isPostSimulationSectionsUnlocked = (onboardingStatus: OnboardingStatus | undefined): boolean => {
  if (!onboardingStatus) return false;

  const simulationComplete = onboardingStatus.simulation.isCompleted;
  return simulationComplete;
};

export const isSimulationSectionComplete = (onboardingStatus: OnboardingStatus | undefined): boolean => {
  if (!onboardingStatus) return false;

  return onboardingStatus.simulation.isCompleted;
};

export const hasStartedPostSimulationSections = (onboardingStatus: OnboardingStatus | undefined): boolean => {
  if (!onboardingStatus) return false;

  const hasStartedFleetSetup =
    isSectionComplete(onboardingStatus.fleetSetup.addOwnVehicles) ||
    isSectionComplete(onboardingStatus.fleetSetup.addOwnDrivers) ||
    isSectionComplete(onboardingStatus.fleetSetup.inviteOwnPartnerDrivers);

  const hasStartedOnboardingClients =
    isSectionComplete(onboardingStatus.onboardingClients.registerClient) ||
    isSectionComplete(onboardingStatus.onboardingClients.uploadClients) ||
    isSectionComplete(onboardingStatus.onboardingClients.setupCompanyProfile);

  const hasStartedAddOns = isSectionComplete(onboardingStatus.addOns.setupAddons);

  return hasStartedFleetSetup || hasStartedOnboardingClients || hasStartedAddOns;
};

export const shouldShowSimulationCompleteSnackbar = (onboardingStatus: OnboardingStatus | undefined): boolean => {
  return isSimulationSectionComplete(onboardingStatus) && !hasStartedPostSimulationSections(onboardingStatus);
};
